// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar__LlKCu","link":"Header_link__2Vrxj"};